import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {

};

const getters = { //实时监听state值的变化(最新状态)

};

const mutations = {

};

const actions = {};

export default new Vuex.Store({
	state,
	getters,
	mutations,
	actions
});



// WEBPACK FOOTER //
// ./src/store/index.js